import React, { useState, useEffect, useContext } from 'react';
import { UseFormMethods } from 'react-hook-form';
import context from '../../../context/product/context';
import { TextBox } from './textbox';
import { unMaskValue } from '../common-functions';

type TextBoxPhoneProps = {
	phoneLength?: number;
	setValue?: UseFormMethods['setValue'];
	value: string;
	onChange: Function;
	unmask?: (value: string) => string;
	clearErrors: UseFormMethods['clearErrors'];
	onFocus: Function;
	onBlur: Function;
	hookProps: {
		errors: UseFormMethods['errors'];
		register: UseFormMethods['register'];
	};
	label?: string;
	name: string;
};

const defaultPhoneLength = 10;

export const TextBoxPhone: React.FC<TextBoxPhoneProps> = ({
	phoneLength = defaultPhoneLength,
	setValue,
	value,
	onChange,
	unmask = (val: string) => unMaskValue(val, '_', '(###) ###-####'),
	clearErrors,
	onFocus,
	onBlur,
	hookProps,
	label,
	name,
}) => {
	const ctxt = useContext(context);
	const [phoneLabel, setPhoneLabel] = useState(label);
	const handleChange = (change: React.ChangeEvent<HTMLInputElement>) => {
		onChange(unmask(change.target.value));
		clearErrors(name);
	};
	useEffect(() => {
		if (label) {
			setPhoneLabel(label);
		} else {
			setPhoneLabel(ctxt.json.getField(name)?.label);
		}
	}, []);
	return (
		<TextBox
			label={phoneLabel}
			name={name}
			type={'tel'}
			maxLength={phoneLength}
			minLength={phoneLength}
			format="(###) ###-####"
			mask={'_'}
			placeholder={'(xxx) xxx-xxxx'}
			setValue={setValue}
			value={value}
			onChange={handleChange}
			onFocus={onFocus}
			{...hookProps}
			onBlur={onBlur}
		/>
	);
};
